import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, TouchableOpacity, ScrollView } from 'react-native';
import { DataStore, Predicates, SortDirection } from 'aws-amplify';
import { Message, SendPicture, UserGroup, AppUser, GroupConversation } from '../../models';
import * as CmnUtil from '../../components/CmnUtil';
import IconImages from '../../components/IconImages';

/** ================================
*  チャット画面
*  ================================*/
const ChatList = ({ navigation }: { navigation: any }) => {

  // 全グループリスト
  const [groupConvList, setGroupConvList] = useState<GroupConversation[]>([]);
  const [userInfo, setUserInfo] = useState<AppUser | undefined>(undefined);

  useEffect(() => {
    // 情報読出
    countUnread();

    // チャット情報の購読
    const groupConversation = DataStore.observe(GroupConversation).subscribe(countUnread);
    const message = DataStore.observe(Message).subscribe(countUnread);
    const sendPicture = DataStore.observe(SendPicture).subscribe(countUnread);
    return () => {
      groupConversation.unsubscribe();
      message.unsubscribe();
      sendPicture.unsubscribe();
    }
  }, []);

  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      // 情報読出
      countUnread();
    });

    // チャット情報の購読
    const groupConversation = DataStore.observe(GroupConversation).subscribe(countUnread);
    const message = DataStore.observe(Message).subscribe(countUnread);
    const sendPicture = DataStore.observe(SendPicture).subscribe(countUnread);
    return () => {
      unsubscribe();
      groupConversation.unsubscribe();
      message.unsubscribe();
      sendPicture.unsubscribe();
    }
  }, [navigation]);

  // 情報読出
  const countUnread = async () => {
    const appUser = await CmnUtil.getCurrentUser();
    setUserInfo(appUser);
    const groupConversation = (await DataStore.query(GroupConversation)).filter(c => c.group.id === appUser?.group.id);
    setGroupConvList([...groupConversation]);
  }

  return (
    <View style={styles.container}>
      <ScrollView style={styles.userItemContainer}>
        {groupConvList.map((data: GroupConversation, index: number) => (
          <ChatCard key={index} navigation={navigation} groupConversation={data} userInfo={userInfo!} />
        ))}
      </ScrollView>
    </View>
  );
}

// チャット一覧の1組織分
const ChatCard = ({ navigation, groupConversation, userInfo }: { navigation: any, groupConversation: GroupConversation, userInfo: AppUser }) => {

  const [partner, setPartner] = useState<UserGroup | undefined>(undefined);
  const [lastMessage, setLastMessage] = useState('');
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    (async () => {
      if (groupConversation.isIntergroup) {
        // 相手のルーム取得
        const targetConversation = (await DataStore.query(GroupConversation)).filter(c => c.conversation.id == groupConversation.conversation.id && c.group.id != groupConversation.group.id);

        // 相手のユーザー情報取得
        const tmpPartner = (await DataStore.query(UserGroup, targetConversation[0].group.id));
        setPartner(tmpPartner);
      } else {
        setPartner(groupConversation.group);
      }

      // 最終メッセージ取得
      const message_data = (await DataStore.query(Message, Predicates.ALL,
        {
          sort: s => s.createdAt(SortDirection.DESCENDING),
        })).filter(c => c.conversation.id === groupConversation.conversation.id);
      if (message_data.length > 0) {
        setLastMessage(message_data[0].content);
      }

      // 未読メッセージ数取得
      const message = (await DataStore.query(Message)).filter(c => c.conversation.id === groupConversation.conversation.id && c.sender.id != userInfo.id && c.isRead == false);
      const sendPicture = (await DataStore.query(SendPicture)).filter(c => c.conversation.id === groupConversation.conversation.id && c.sender.id != userInfo.id && c.isRead == false);
      setUnread(message.length + sendPicture.length);

    })();
  }, [groupConversation]);

  // チャットルームへ遷移
  const goChatMain = () => {
    navigation.navigate('ChatMain', {
      'groupConversation': groupConversation,
      'userInfo': userInfo,
      'partner': partner,
    });
  };

  return (
    <TouchableOpacity style={styles.userItem} onPress={() => { goChatMain() }}>
      <CmnUtil.S3Image imageKey={partner?.icon} style={styles.userImage} defaultSource={IconImages.ic_group} />
      <View style={{ width: '80%' }}>
        <Text style={styles.userName}>{partner?.groupName}</Text>
        <Text ellipsizeMode='tail' numberOfLines={2}>{lastMessage}</Text>
      </View>
      <CmnUtil.Badge count={unread} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  userItemContainer: {
    height: 1,
  },
  userItem: {
    width: '100%',
    height: 80,
    borderBottomWidth: 2,
    borderColor: '#80aed5',
    borderStyle: 'solid',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10
  },
  userImage: {
    borderRadius: 25,
    width: 50,
    height: 50,
    backgroundColor: 'gray',
    marginRight: 10
  },
  userName: {
    fontWeight: 'bold',
    fontSize: 18
  },
});

export default ChatList;
